import styled from 'styled-components';

export const ChooseAvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UploadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
